import * as React from "react";
import { VOLANTINO_PRIMARY } from "../../../helper/utility";

const LinkInterno = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_1"
    data-name="Livello 1"
    viewBox="0 0 85.04 85.04"
    {...props}
  >
    <defs></defs>
    <circle
      cx={42.52}
      cy={42.52}
      r={38.12}
      style={{
        fill: "#fff"
      }}
    />
    <circle
      cx={42.52}
      cy={42.52}
      r={34.15}
      style={{
        fill: VOLANTINO_PRIMARY,
        stroke: VOLANTINO_PRIMARY
      }}
    />
    <rect
      width={9.64}
      height={20.36}
      x={47.88}
      y={22.16}
      rx={4.82}
      transform="rotate(45 52.695 32.337)"
      style={{ fill: "#fff", stroke: "#fff" }}
    />
    <rect
      width={9.64}
      height={20.36}
      x={27.52}
      y={42.52}
      rx={4.82}
      transform="rotate(45 32.339 52.705)"
      style={{ fill: "#fff", stroke: "#fff" }}
    />
    <path
      d="M48.87 36.14 36.99 48.02M50.95 56.49l5.54 5.55 5.55-5.55"
      style={{ stroke: "#fff", fill: "none", strokeWidth: "2" }}
    />
    <path 
      d="M56.49 62v-9.2a5.69 5.69 0 0 0-5.69-5.69" 
      style={{ stroke: "#fff", fill: "none", strokeWidth: "2" }}
    />
  </svg>
);
export default LinkInterno;